import moment from "moment";

function STATES_DC_COMPRA({ staneName }) {
  if (staneName === "formCompra")
    return {
      dc_id: "",
      dc_docn: "",
      dc_identificador: moment(new Date()).format("YYYYMMDDHHmmssSSS"),
      dc_proveedor: "",
      prov_proveedor: "",
      dc_procesado: "",
      dcd_total: "",
      dc_fecha_procesado: "",
      dc_fecha: moment(new Date()).format("YYYY-MM-DD"),
      dc_descripcion: "",
      dc_status: "",
      bod_id: "",
      bod_nombre: "",
    };
  if (staneName === "formCompraDetalle")
    return {
      dcd_id: "",
      dcd_articulo: "",
      dcd_precio: "",
      dcd_cantidad: "1",
      dcd_itbms: "",
      dcd_descuento: "",
      dcd_total: "",
      dcd_descuento_number: "",
      art_descripcion: "",
      art_upc: "",
      art_itbm_cod_c: "",
      art_itbm_compra: "",
      art_serie: "",
    };
}
function STATES_GAS_GASTOS({ staneName }) {
  if (staneName === "formGastos")
    return {
      gs_id: "",
      gs_monto: "",
      gs_desc: "",
      gs_tipo: "",
      gs_imgType: "",
      gs_file: "",
      tgs_desc: "",
      gs_fecha: moment(new Date()).format("YYYY-MM-DD"),
      gs_sts: "",
    };
  if (staneName === "formTipoGastos")
    return {
      tgs_id: "",
      tgs_desc: "",
      tgs_sts: "",
    };
}
function STATES_RE_RECUENTO({ staneName }) {
  if (staneName === "formRecuento")
    return {
      re_id: "",
      re_identificador: moment(new Date()).format("YYYYMMDDHHmmssSSS"),
      re_fecha: moment(new Date()).format("YYYY-MM-DD"),
      re_fecha_procesado: "",
      re_procesado: "",
      re_descripcion: "",
      usr_nombre: "",
      bod_nombre: "",
    };

  if (staneName === "formRecuentoDetalle")
    return {
      red_id: "",
      red_articulo: "",
      red_cantidad: "1",
      red_identificador: "",
      art_upc: "",
      art_descripcion: "",
      art_serie: "",
    };
}
function STATES_COM_COMPANIA({ staneName }) {
  if (staneName === "formCompania") {
    return {
      bod_suc: "",
      com_nombre: "",
      com_ruc: "",
      com_dv: "",
      com_direccion: "",
      com_telefono: "",
      com_telefono2: "",
      com_email: "",
      com_fax: "",
      com_web: "",
      com_info_interes: "",
      com_cotizacion_info: "",
    };
  }
}
function STATES_MOV_MOVIMIENTO({ staneName }) {
  if (staneName === "formMovimiento") {
    return {
      mov_id: "",
      mov_identificador: moment(new Date()).format("YYYYMMDDHHmmssSSS"),
      mov_fecha: moment(new Date()).format("YYYY-MM-DD"),
      mov_fecha_procesado: "",
      mov_descripcion: "",
      mov_bodega_desde: "",
      mov_bodega_hacia: "",
      mov_bodega_desde_nombre: "",
      mov_bodega_hacia_nombre: "",
      mov_unique: "",
      mov_procesado: "",
      mov_sts: "",
      inv_qty: "0",
    };
  }
  if (staneName === "formMovimientoDetalle")
    return {
      movd_id: "",
      movd_articulo: "",
      movd_cantidad: "1",
      movd_identificador: "",
      art_upc: "",
      art_descripcion: "",
      inv_qty: "0",
      art_serie: "",
    };
}

function STATES_FAC_FACTURA({ staneName, usr_id }) {
  if (staneName === "formRetencion")
    return {
      re_id: "",
      re_desc: "",
      re_porc: "",
      re_codigo: "",
      re_sts: "",
    };
  if (staneName === "formRestaurante")
    return {
      res_nombre: "",
      res_mesa_selected: "",
      res_mesa_id: "",
      res_categoria_selected: "",
      res_categoria_id: "",
      current_ord_identificador: "",
      ordd_entregado: "",
      ord_number: "",
      code_cash: "",
      ord_info_comanda: "",
      ord_para_llevar: "",
    };
  if (staneName === "formDetailItem")
    return {
      art_categoria: "",
      art_descripcion: "",
      art_id: "",
      art_img: null,
      art_imgName: "",
      art_itbm_cod_v: "",
      art_itbm_venta: "",
      art_precio: "",
      art_precio2: "",
      art_precio3: "",
      art_referencia: "",
      art_restaurante: "",
      art_upc: "",
      cat_descripcion: "",
      itbm_descripcion: "",
      mar_descripcion: "",
    };
  if (staneName === "formFactura")
    return {
      fac_id: "",
      fac_identificador: moment(new Date()).format("YYYYMMDDHHmmssSSS"),
      fac_cliente: "",
      fac_vendedor: usr_id,
      fac_fecha: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      fac_caja: "",
      fac_sts: "",
      fac_garantia: "",
      fac_text_invoice: "",
    };
  if (staneName === "formCredito")
    return {
      crp_id: "",
      crp_fac_identificador: "",
      crp_cliente: "",
      crp_monto: "0",
      crp_fecha: "",
      crp_status: "",
    };
  if (staneName === "formPrecio")
    return {
      art_precio: "",
      art_precio2: "",
      art_precio3: "",
    };
  if (staneName === "formPagoCredito")
    return {
      crd_fecha: "",
      crd_monto: "",
      crp_monto: "",
      fac_id: "",
      fac_identificador: "",
      cli_name: "",
      cli_ruc: "",
      crp_id: "",
    };
  if (staneName === "formAnulacion")
    return {
      motivo_anulacion: "",
      docNumber: "",
      fac_id: "",
      fac_identificador: "",
      fac_fecha: "",
      fac_cliente: "",
      fac_recibo: "",
      fac_mensaje: "",
      fac_cufe: "",
      fac_resultado: "",
      fac_date_anulacion: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      cli_nombre: "",
      cli_ruc: "",
      cli_dv: "",
      fac_total: "",
    };
  if (staneName === "formListPago")
    return {
      list_id: "",
      list_identificador: "",
      list_fpago: "",
      list_monto: "",
      list_sts: "",
    };
  if (staneName === "dataCompania_f")
    return {
      bod_suc: "",
      com_nombre: "",
      com_ruc: "",
      com_dv: "",
      com_direccion: "",
      com_telefono: "",
      com_telefono2: "",
      com_email: "",
      com_fax: "",
      com_web: "",
      com_info_interes: "",
    };
  if (staneName === "formClientes")
    return {
      cli_id: "",
      cli_suc: "",
      cli_sts: "",
      cli_nombre: "",
      cli_direccion: "",
      cli_telefono: "",
      cli_telefono2: "",
      cli_ruc: "",
      cli_dv: "",
      cli_email: "",
      cli_limitc: "",
      cli_credito: "",
      cli_exento: "0",
      cli_tipo_clienteFE: "02",
      crd_monto_c: "",
      crd_monto_p: "",
      re_id: "",
      re_desc: "",
      re_porc: "",
      re_codigo: "",
    };
  if (staneName === "formDropDownCliente") {
    return {
      cli_id: "",
      cli_nombre: "",
      cli_ruc: "RUC",
      cli_email: "",
      cli_dv: "",
    };
  }
  if (staneName === "formDropDownFPago") {
    return {
      frm_id: "",
      frm_code: "",
      frm_descripcion: "",
    };
  }
  if (staneName === "formOrdenesDetalle") {
    return {
      ordd_id: "",
      ordd_identificador: "",
      ordd_articulo: "",
      art_descripcion: "",
      art_upc: "",
      ordd_precio: "",
      ordd_cantidad: "0",
      ordd_itbms: "0",
      ordd_art_descripcion: "",
      ordd_itbms_code: "",
      art_itbm_cod_v: "",
      ordd_descuento: "",
      ordd_total: "",
      ordd_descuento_number: "",
      art_itbm_venta: "",
      co_printer: "",
    };
  }
  if (staneName === "formFacturaDetalle") {
    return {
      fcd_id: "",
      fcd_identificador: "",
      fcd_articulo: "",
      art_descripcion: "",
      art_upc: "",
      fcd_precio: "",
      fcd_cantidad: "0",
      fcd_itbms: "0",
      fcd_art_descripcion: "",
      fcd_itbms_code: "",
      art_itbm_cod_v: "",
      fcd_descuento: "0",
      fcd_total: "",
      fcd_descuento_number: "",
      art_itbm_venta: "",
      inv_qty: "",
      art_servicio: "0",
      art_catalogo: "0",
      ser_id: "",
      ser_serie: "",
    };
  }
  if (staneName === "cotizacionList") {
    return {
      cot_descripcion: "",
      cli_nombre: "",
      cli_ruc: "",
      cot_fecha: "",
    };
  }
  if (staneName === "formCotizacionDetail") {
    return {
      cotd_articulo: "",
      cotd_cantidad: "",
      cotd_itbms: "",
      cotd_precio: "",
      cotd_total: "",
      art_upc: "",
    };
  }
  return null;
}

function STATES_COT_COTIZACION({ staneName }) {
  if (staneName === "formPrecio") {
    return {
      art_precio: "",
      art_precio2: "",
      art_precio3: "",
    };
  }
  if (staneName === "formCompania") {
    return {
      bod_suc: "",
      com_nombre: "",
      com_ruc: "",
      com_dv: "",
      com_direccion: "",
      com_telefono: "",
      com_telefono2: "",
      com_email: "",
      com_fax: "",
      com_web: "",
      com_info_interes: "",
      com_cotizacion_info: "",
      com_cot_image: "",
      com_instagram: "",
      com_tiktok: "",
      com_facebook: "",
    };
  }
  if (staneName === "formCotCotizacion") {
    return {
      cot_id: "",
      cot_identificador: moment(new Date()).format("YYYYMMDDHHmmssSSS"),
      cot_cliente: "",
      cot_nombre: "",
      cot_fecha: moment(new Date()).format("YYYY-MM-DD"),
      cot_vendedor: "",
      cot_status: "",
      cot_garantia: "",
      cot_garantia_name: "",
      cot_descripcion: "",
      cot_validez: "15",
    };
  }
  if (staneName === "formCotCotizacionDetalle") {
    return {
      cotd_id: "",
      cotd_identificador: "",
      cotd_articulo: "",
      cotd_cantidad: "",
      cotd_descuento: "",
      cotd_descuento_number: "",
      cotd_precio: "",
      cotd_itbms: "",
      art_itbm_venta: "",
      cotd_total: "",
      art_descripcion: "",
      art_upc: "",
      art_itbm_cod_v: "",
      art_imgName: "",
      art_referencia: "",
    };
  }
  if (staneName === "formClientes") {
    return {
      cli_id: "",
      cli_suc: "",
      cli_sts: "",
      cli_nombre: "",
      cli_direccion: "",
      cli_telefono: "",
      cli_telefono2: "",
      cli_ruc: "",
      cli_dv: "",
      cli_email: "",
      cli_limitc: "",
      cli_credito: "",
      re_id: "",
      re_desc: "",
      re_porc: "",
      re_codigo: "",
      cli_exento: "0",
      cli_tipo_clienteFE: "02",
    };
  }
  if (staneName === "formDropDownCliente") {
    return {
      cli_id: "",
      cli_nombre: "",
      cli_ruc: "RUC",
      cli_email: "",
      cli_dv: "",
    };
  }
  return null;
}

function STATES_ART_ARTICULO({ staneName }) {
  if (staneName === "formArticulos") {
    return {
      art_id: "",
      art_upc: "",
      art_sucursal: "",
      art_categoria: "",
      art_proveedor: "",
      art_marca: "",
      art_descripcion: "",
      art_costo: "",
      art_precio: "",
      art_precio2: "",
      art_precio3: "",
      art_referencia: "",
      art_linea_roja: "0",
      art_img: "",
      art_imgdataurl: "",
      art_imgType: "",
      art_imgName: "",
      art_serie: "",
      art_itbm_venta: "",
      art_itbm_compra: "",
      art_sts: "",
      inv_id: "",
      inv_qty: "",
      art_restaurante: "0",
      art_servicio: "0",
      art_catalogo: "0",
      art_acompanamiento: "0",
      art_comanda: "1",
      co_desc: "",
    };
  }
  if (staneName === "formDropDown") {
    return {
      mar_id: "",
      mar_descripcion: "",
      cat_id: "",
      cat_descripcion: "",
      prov_id: "",
      prov_nombre: "",
      bod_id: "",
      bod_nombre: "",
      itbm_cod_venta: "",
      itbm_porc_v: "",
      itbm_descripcion_venta: "",
      itbm_cod_compra: "",
      itbm_porc_c: "",
      itbm_descripcion_compra: "",
    };
  }
  return null;
}

function STATES_CLI_CLIENTES({ staneName }) {
  if (staneName === "formClientes") {
    return {
      cli_id: "",
      cli_suc: "",
      cli_sts: "",
      cli_nombre: "",
      cli_direccion: "",
      cli_telefono: "",
      cli_telefono2: "",
      cli_ruc: "",
      cli_dv: "",
      cli_email: "",
      cli_limitc: "",
      cli_credito: "",
      re_id: "",
      re_desc: "",
      re_porc: "",
      re_codigo: "",
      cli_exento: "0",
      cli_tipo_clienteFE: "02",
    };
  }
  return null;
}
export { STATES_CLI_CLIENTES, STATES_ART_ARTICULO, STATES_FAC_FACTURA, STATES_DC_COMPRA, STATES_RE_RECUENTO, STATES_MOV_MOVIMIENTO, STATES_COT_COTIZACION, STATES_COM_COMPANIA, STATES_GAS_GASTOS };
